// extracted by mini-css-extract-plugin
export var base = "_2d-0";
export var updateBanner = "_2d-1";